export default __webpack_public_path__ + "static/media/cafeshow_behind02.2105a77f.png";